import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { PlatformEnum } from '@panamax/app-state';
import {
  SortFields,
  SortOption,
  SortSelection,
  SortType,
} from '@shared/models/sort.model';
import {
  SortDirections,
  SortableSectionHeader,
} from '../sortable-section/models/sortable-section.model';

@Component({
  selector: 'app-usf-sort-modal',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './usf-sort-modal.component.html',
  styleUrls: ['./usf-sort-modal.component.scss'],
})
export class UsfSortModalComponent implements OnInit {
  @Input() platformType: PlatformEnum;
  @Input() sortOptions: SortOption[];
  @Input() sortSelection: SortSelection;

  @Output()
  saveSortEmitter: EventEmitter<SortableSectionHeader> = new EventEmitter();
  @Output()
  resetSortEmitter: EventEmitter<boolean> = new EventEmitter();
  @Output()
  dismissModalEmitter: EventEmitter<boolean> = new EventEmitter();

  readonly SortDirections = SortDirections;
  readonly SortFields = SortFields;
  readonly PlatformEnum = PlatformEnum;
  sortDirection: string;
  newSortSelected = false;

  constructor() {}

  ngOnInit(): void {
    this.sortDirection = this.sortSelection.sortValue;
  }

  isAsc(sortOption: string): boolean {
    return sortOption === SortDirections.asc;
  }

  sort(field: SortType) {
    this.newSortSelected = true;
    if (this.sortSelection.fieldName === field) {
      this.sortDirection =
        this.sortDirection === SortDirections.asc
          ? SortDirections.desc
          : SortDirections.asc;
    } else {
      const { sortDirection: defaultDirection } = this.sortOptions.find(
        option => option.sortName === field,
      );
      this.sortDirection = defaultDirection;
    }

    this.sortSelection = { fieldName: field, sortValue: this.sortDirection };
    this.saveSort();
  }

  saveSort() {
    const sortUpdate: SortableSectionHeader = {
      headerName: this.sortSelection.fieldName,
      sortDirection: this.sortSelection.sortValue,
    };
    this.saveSortEmitter.emit(sortUpdate);
  }

  resetSort() {
    this.resetSortEmitter.emit(true);
    this.dismissModalEmitter.emit(true);
  }

  dismiss() {
    if (!this.newSortSelected) {
      this.saveSort();
    }
    this.dismissModalEmitter.emit(true);
  }
}
